/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Sujith Dachepally
 * Created: 10/11/23
 */

import React from 'react';
import { Assignment } from '@/wpt-lib/interfaces/Assignment';
import { Tile } from '@/components/Tile';
import AssignmentStatusDialog from '@/components/pages/Admin/UserStatus/AssignmentStatusDialog';

export interface UserStatusProps {
    assignment: Assignment;
    currentAssignment: Assignment;
    refresh: () => void;
}
const AssignmentStatusEditor = ({ assignment, currentAssignment, refresh }: UserStatusProps) => {
    return (
        <Tile colspan={2} collapsable overflowX="auto" heading="Status" defaultOpen>
            <AssignmentStatusDialog assignment={assignment} currentAssignment={currentAssignment} refresh={refresh} />
        </Tile>
    );
};

export default AssignmentStatusEditor;
